export const FLITCHING_HISTORY_LIST_REQUEST = "FLITCHING_HISTORY_LIST_REQUEST";
export const FLITCHING_HISTORY_LIST_SUCCESS = "FLITCHING_HISTORY_LIST_SUCCESS";
export const FLITCHING_HISTORY_LIST_FAILED = "FLITCHING_HISTORY_LIST_FAILED";
